<div class="dropzone-wrapper">
    <label #inputRef (click)="testModal($event)">
        <div class="label">{{ _label }}</div>
        <input type="file" [multiple]="multiple" (change)="onFilesChange($event)">
    </label>
</div>